"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateEngagementAssociations = updateEngagementAssociations;

var _AssociationsActions = require("crm_data/associations/AssociationsActions");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _difference = _interopRequireDefault(require("transmute/difference"));

var _ObjectAssociationTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectAssociationTypes"));

// Given an engagement's existing associations and new associations,
// computes the difference and calls associate or disassociate for each
// record to associate or disassociate with the engagement.
var objectTypes = [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET];

function addAssociation(subjectId, objectType, associationsToAdd) {
  if (!associationsToAdd.size) {
    return;
  }

  (0, _AssociationsActions.associate)(subjectId, associationsToAdd, _ObjectTypes.ENGAGEMENT, objectType);
}

function removeAssociation(subjectId, objectType, associationsToRemove) {
  if (!associationsToRemove.size) {
    return;
  }

  associationsToRemove.map(function (associationToRemove) {
    return (0, _AssociationsActions.disassociate)(subjectId, associationToRemove, _ObjectTypes.ENGAGEMENT, objectType);
  });
}

function updateEngagementAssociations(engagementId, oldAssociations, newAssociations) {
  if (!oldAssociations.equals(newAssociations)) {
    objectTypes.forEach(function (objectType) {
      var objectKey = _ObjectAssociationTypes.default[objectType];

      if (!oldAssociations.get(objectKey).equals(newAssociations.get(objectKey))) {
        var associationsToAdd = (0, _difference.default)(oldAssociations.get(objectKey), newAssociations.get(objectKey));
        var associationsToRemove = (0, _difference.default)(newAssociations.get(objectKey), oldAssociations.get(objectKey));
        addAssociation(engagementId, objectType, associationsToAdd);
        removeAssociation(engagementId, objectType, associationsToRemove);
      }
    });
  }
}